import { api } from './client';
import type { FolderItem, FileItem } from '../stores/fileStore';

interface ListFoldersResponse {
  folders: FolderItem[];
}

interface GetFolderResponse {
  folder: FolderItem;
  subfolders: { id: string; name: string; color?: string | null }[];
  files: FileItem[];
}

interface BreadcrumbResponse {
  breadcrumb: { id: string; name: string }[];
}

interface FolderFilesResponse {
  folderName: string;
  files: {
    id: string;
    name: string;
    size: number;
    mimeType: string;
    relativePath: string;
  }[];
  totalSize: number;
  fileCount: number;
}

// Move destinations types
export interface MoveDestinationFolder {
  id: string;
  parentId: string | null;
  name: string;
  color: string | null;
}

export interface MoveDestinationProject {
  id: string;
  name: string;
  status: string;
  folders: MoveDestinationFolder[];
}

export interface MoveDestinationClient {
  id: string;
  name: string;
  company: string | null;
  projects: MoveDestinationProject[];
}

export interface MoveDestinationsResponse {
  personalFolders: MoveDestinationFolder[];
  clients: MoveDestinationClient[];
}

export const foldersApi = {
  list: (parentId?: string | null, clientId?: string, projectId?: string) => {
    const params = new URLSearchParams();
    if (parentId !== undefined) {
      params.set('parentId', parentId === null ? 'null' : parentId);
    }
    if (projectId) {
      params.set('projectId', projectId);
    } else if (clientId) {
      params.set('clientId', clientId);
    }
    return api.get<ListFoldersResponse>(`/folders?${params.toString()}`);
  },

  get: (id: string) => api.get<GetFolderResponse>(`/folders/${id}`),

  getBreadcrumb: (id: string) =>
    api.get<BreadcrumbResponse>(`/folders/${id}/breadcrumb`),

  create: (data: { name: string; parentId?: string | null; color?: string; projectId?: string; clientId?: string }) =>
    api.post<{ folder: FolderItem }>('/folders', data),

  update: (
    id: string,
    data: Partial<{ name: string; parentId: string | null; color: string | null }>
  ) => api.patch<{ folder: FolderItem }>(`/folders/${id}`, data),

  delete: (id: string) => api.delete<{ success: boolean; storageUsed: number }>(`/folders/${id}`),

  getFilesForDownload: (id: string) =>
    api.get<FolderFilesResponse>(`/folders/${id}/files`),

  getMoveDestinations: () =>
    api.get<MoveDestinationsResponse>('/folders/move-destinations'),
};
